import * as React from 'react';
import Toolbar from '@material-ui/core/Toolbar';

const CustomToolbar = (props) => {
    return <Toolbar {...props} />;
};

export { CustomToolbar as Toolbar };
